import { MemberRole, PrincipalType } from '@lucidlink/dto/validation';
import { MemberRoleUpdateSchema, } from '@lucidlink/dto/web-service-api';
import { encryptCryptoKeyWithPublicKey } from '@lucidlink/ts-crypto/crypto';
export class UpdateMemberError extends Error {
    constructor(message) {
        super(message);
    }
}
const getAdminPrivateKey = async ({ memberId, adminCrypto, principalsCrypto, }) => {
    const { encryptPair: adminKeys } = await adminCrypto.verifyAndGetAdminKeys();
    const { keys: memberKeys } = await principalsCrypto.verifyAndGetPrincipalKeys(memberId, {
        assertType: PrincipalType.MEMBER,
    });
    if (!memberKeys) {
        throw new Error('Invalid member crypto');
    }
    return encryptCryptoKeyWithPublicKey(adminKeys.privateKey, memberKeys.publicKey);
};
export const prepareUpdateRole = async ({ params, adminCrypto, principalsCrypto, }) => {
    switch (params.role) {
        case MemberRole.OWNER:
            throw new Error('Cannot use the owner role');
        case MemberRole.ADMIN: {
            return MemberRoleUpdateSchema.parseAsync({
                role: params.role,
                eAdminPrivateKeyByMemberKey: await getAdminPrivateKey({
                    memberId: params.memberId,
                    adminCrypto,
                    principalsCrypto,
                }),
            });
        }
        case MemberRole.COLLABORATOR: {
            return MemberRoleUpdateSchema.parse({
                role: params.role,
                eAdminPrivateKeyByMemberKey: null,
            });
        }
        case MemberRole.FILESPACE_ADMIN: {
            return MemberRoleUpdateSchema.parse({
                role: params.role,
                eAdminPrivateKeyByMemberKey: await getAdminPrivateKey({
                    memberId: params.memberId,
                    adminCrypto,
                    principalsCrypto,
                }),
                filespaceIds: params.filespaceIds,
            });
        }
        case MemberRole.GUEST: {
            throw new UpdateMemberError('Cannot update role to guest');
        }
        default:
            throw new Error('Unreachable!');
    }
};
